if (!customElements.get("vp-mobile-header-menus")) {
  class MobileHeaderMenus extends HTMLElement {
    constructor() {
      super();
      this.mobileFirstLayerMenus = this.querySelectorAll(".vp-mobile-menu-drawer__link");
    }

    connectedCallback() {
      this.handleMobileFirstLayerMenusClick();
    }

    handleMobileFirstLayerMenusClick() {
      this.mobileFirstLayerMenus.forEach((menu) => {
        menu.addEventListener("click", () => {
          this.mobileFirstLayerMenus.forEach((item) => {
            item.closest(".vp-mobile-menu-drawer__link-container")?.classList.remove("active");
          });
          menu.closest(".vp-mobile-menu-drawer__link-container")?.classList.add("active");
          console.log(menu, "menu");
        });
      });
    }
  }
  customElements.define("vp-mobile-header-menus", MobileHeaderMenus);
}
